/* eslint-disable max-len */
export const survey = {
  questionnaire: 'Анкета',
  survey: 'Анкетирование',
  question: 'Вопрос',
  'survey-finished': 'Анкета завершена. Спасибо!',
  'answers-successfuly-sent': 'Анкета завершена. Спасибо!',
  'to-next-stage': 'Перейти к следующему этапу',
  'nth-question-from-x': 'Вопрос {current} из {total}',
  'response-time': 'Время на ответ',
  'finish-questionnaire': 'Завершить анкету',
  'next-question': 'Следующий вопрос',
  'video-interview': 'Видеоинтервью',
  'selection-stages': 'Этапы отбора',
  'start-interview-notice': 'Для того чтобы пройти видеоинтервью, необходимо записать ответы на вопросы. Вопросы могут быть заданы в текстовом формате или в формате видео. Для записи тебе понадобятся компьютер с камерой и микрофоном, смартфон или планшет.',
};
